import { getCountries } from "../services/countryService";
import { useQuery } from "@tanstack/react-query";

const useCountries = () => useQuery({
    queryKey: ['countries'],
    queryFn: () => getCountries().then(res => res.data),
    staleTime: 1000 * 60 * 60 * 24 * 365 // 1 year
});

export default useCountries;